import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { generateSearchFormItem, getTreeData } from "../../../../utils/helper";
import { SearchAccordion } from "../../../common";
import { defaultFilter, ISearchProps } from "./type";

const Search = ({ filter, setFilter }: ISearchProps) => {
  const { t } = useTranslation();
  const T = (name: string) => {
    return t(`Mail.${name}`);
  };

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "sendTime",
                },
                {
                  type: "text",
                  name: "playerID",
                  label: "playerID",
                },
                {
                  type: "text",
                  name: "title",
                  label: "title",
                },
                {
                  type: "multiSelect",
                  name: "status",
                  label: "status",
                  treeData: getTreeData(["未寄出", "已寄出"]),
                },
              ],
              defaultFilter(),
              T
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
